export function initCatalogMore(container: HTMLElement | Document | null = null) {
    // Если передан контейнер (таб), ищем элементы внутри него, иначе ищем глобально
    const searchScope = container || document;
    
    // Проверяем, не инициализирован ли уже этот контейнер (только для HTMLElement)
    if (container && container instanceof HTMLElement) {
        if (container.dataset.catalogMoreInitialized === 'true') return;
        container.dataset.catalogMoreInitialized = 'true';
    }
    
    // Получаем элементы внутри контейнера
    const catalogItems: NodeListOf<HTMLElement> = searchScope.querySelectorAll('.catalog-item');
    const buttonMore: HTMLElement | null = searchScope.querySelector('.button-more');
    const shownText: HTMLElement | null = searchScope.querySelector('.catalog-pagination div.fw-600');

    const catalogItemsContainer: HTMLElement | null = searchScope.querySelector('.catalog-items');
    const hasSmallList: boolean = catalogItemsContainer?.classList.contains('small-list') || false;
    const hasShipList: boolean = catalogItemsContainer?.classList.contains('ship-list') || false;
    
    // small-list: всегда 2 карточки.
    // ship-list: до 991px показываем 5 карточек, на больших экранах 10.
    // Остальные списки: 10 карточек.
    const itemsPerPage: number = hasSmallList ? 2 : (hasShipList ? (window.innerWidth <= 767 ? 2 : 5) : 10);
    let currentIndex: number = itemsPerPage;
    let expanded: boolean = false; // флаг, показываем ли все

    // Функция для обновления текста "Показано X из Y"
    function updateShownText(): void {
        if (!shownText) return;
        const shown: number = Math.min(currentIndex, catalogItems.length);
        shownText.textContent = `Показано ${shown} из ${catalogItems.length}`;
    }

    // Скрываем все элементы после первых 10
    catalogItems.forEach((item, i) => {
        if (i >= itemsPerPage) item.style.display = 'none';
    });
    updateShownText();

    if (buttonMore) {
        // Удаляем старые обработчики, если они есть
        const newButtonMore = buttonMore.cloneNode(true) as HTMLElement;
        buttonMore.parentNode?.replaceChild(newButtonMore, buttonMore);
        
        newButtonMore.addEventListener('click', (): void => {
            if (!expanded) {
                // Показать все оставшиеся элементы
                catalogItems.forEach(item => item.style.display = '');
                currentIndex = catalogItems.length;
                newButtonMore.textContent = 'Свернуть';
                expanded = true;
            } else {
                // Свернуть обратно до первых itemsPerPage
                catalogItems.forEach((item, i) => {
                    if (i >= itemsPerPage) item.style.display = 'none';
                });
                currentIndex = itemsPerPage;
                newButtonMore.textContent = 'Показать ещё';
                expanded = false;
            }

            updateShownText();
        });
    }
}
